module.exports = __webpack_public_path__ + "img/exhibits1.15821337.png";